// Core
import React, { Component } from "react";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import TextField from "material-ui/TextField";
import Checkbox from "material-ui/Checkbox";
import { Row, Col } from "react-flexbox-grid";

import { FileStackClient } from '../../services/FileStackService';

import UploadIcon from 'material-ui/svg-icons/file/cloud-upload';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import IconButton from "material-ui/IconButton";

// Instruments
// import { CATEGORIES_LIST, CATEGORIES_LIST_HE } from "../../fixtures/categories";

// const CATEGORIES_LIST_LOCAL =
//   navigator.language.includes('he') ? CATEGORIES_LIST_HE : CATEGORIES_LIST;

class AddEditCardDialog extends Component {
  state = {
    haveError: false,
    isMust: false,
    fieldFocus: false
  };

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.card.id === 0) {
      return {
        standardUrl: '',
        isPhotoRequired: false,
        isCommentRequired: false,
        description: '',

        ...nextProps.card,
        ...nextProps.prefillData,
        ...nextState
      }
    }

    return { ...nextProps.card, ...nextState };
  }

  shouldComponentUpdate() {
    const { activeElement } = this.props;
    const { fieldFocus } = this.state;

    if (activeElement && !fieldFocus) {
      this.setState({ fieldFocus: true });
      this.descriptionInput.focus();
    }

    return !!activeElement;
  }

  onConfirm = () => {
    const { description, standard, id, section, isMust, standardUrl, isPhotoRequired, isCommentRequired } = this.state;
    const { onConfirm, onAddNew } = this.props;

    if (description.length !== 0) {
      onConfirm({ description, standard, id, section, isMust, standardUrl, isPhotoRequired, isCommentRequired });

      if (id === 0) {
        onAddNew({ isMust, section });
      }

      this.setState({ haveError: false });
    } else {
      this.setState({ haveError: true });
    }
  };

  handleChange = (e) => {

    if (e.target.name === 'isPhotoRequired' || e.target.name === 'isCommentRequired') {
      this.setState({[e.target.name]: e.target.checked});

      return;
    }

    this.setState({ [e.target.name]: e.target.value })

  };

  handleChangePleminary = e => this.setState({ isMust: Boolean(e.target.value)});

  _handleUpload = () => {
    FileStackClient.picker({
      maxFiles: 1,
      fromSources: [
        "local_file_system",
        "googledrive",
        "dropbox",
        "gmail",
        "box",
        "onedrive",
        "clouddrive"
      ],
      onUploadDone: (res) => {
        const { filesUploaded } = res;

        if (filesUploaded && filesUploaded[0]) {
          const { url } = filesUploaded[0];

          this.setState({ standardUrl: url});
        }
      }
    }).open();
  };

  removeUpload = () => {
    this.setState({ standardUrl: ''});
  }

  render() {
    const { onClose, activeElement, onCancel } = this.props;
    const { section, description, standard, isMust, id, haveError, standardUrl, isPhotoRequired, isCommentRequired } = this.state;

    const confirmName = id === 0 ? "Add" : "Done";
    // const categories = Object.values(CATEGORIES_LIST_LOCAL);

    return (
      <Dialog onClose={onClose} open={!!activeElement} className="checklistDialog">
        <div
          style={{ fontSize: "20px", fontWeight: "bold", textAlign: "center" }}
        >
          {confirmName} Checklist Item
        </div>
        <Row>
          <Col md={12} sm={12} lg={12}>
            <TextField
              fullWidth
              underlineFocusStyle={{ borderColor: "#6da92e" }}
              sty
              name="section"
              type="text"
              onChange={this.handleChange}
              placeholder="Section (optional)"
              value={section}
              multiLine
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} sm={12} lg={12}>
            <TextField
              fullWidth
              underlineFocusStyle={{ borderColor: "#6da92e" }}
              sty
              name="description"
              type="text"
              onChange={this.handleChange}
              placeholder="Description"
              value={description}
              multiLine
              ref={(description) => { this.descriptionInput = description; }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} sm={12} lg={12}>
            <TextField
              underlineFocusStyle={{ borderColor: "#6da92e" }}
              fullWidth
              name="standard"
              type="text"
              onChange={this.handleChange}
              value={standard}
              placeholder="Standard (optional)"
              multiLine
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} sm={12} lg={12}>
            <div onClick={this._handleUpload} style={{cursor: "pointer"}}>Add standard file <UploadIcon style={{height: 18, width: 18}} /></div>
            {(standardUrl && standardUrl !== '') &&
              <div>
                <a href={standardUrl} target="_blank">File link</a>
                <DeleteIcon onClick={this.removeUpload} style={{marginLeft: 5, height: 18, width: 18, cursor: 'pointer'}} />
              </div>
            }
          </Col>
        </Row>
        <Row>
          <Col md={12} sm={12} lg={12}>
            <Checkbox checked={isPhotoRequired} onCheck={this.handleChange} name="isPhotoRequired" label="Must add image" style={{padding: '10px 0 10px 0'}}/>
            <Checkbox checked={isCommentRequired} onCheck={this.handleChange} name="isCommentRequired" label="Must write description\ details" style={{padding: '10px 0 10px 0'}}/>
          </Col>
        </Row>
        {haveError && (
          <Row style={{ color: "#ef5350" }}>
            Description field is required
          </Row>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <FlatButton label="Cancel" onClick={onCancel} />
          <FlatButton label={confirmName} onClick={this.onConfirm} />
        </div>
      </Dialog>
    );
  }
}

export default AddEditCardDialog;
